import addReducer from './add';
import listReducer from './list';
import detailReducer from './detail';



export default {
    addReducer,
    listReducer,
    detailReducer,
 

};